<template>
  <div class="column is-2">
    <div v-if="folio.items.length > 0">
      <comparador-folio-item
        v-for="(item, index) in folio.items"
        :key="`folio-item-${index}`"
        :item="item"
      />
    </div>
    <div v-else>
      <span><strong>No data</strong></span>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

import ComparadorFolioItem from '@/components/comparador-v2/ComparadorFolioItem'

export default {
  name: 'ComparadorFolio',
  components: { ComparadorFolioItem },
  props: {
    folio: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hover: false
    }
  },
  computed: {
    fecha() {
      return format(parseISO(this.folio.fecha), 'dd/MM HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.column {
  padding: 0.5rem;
}
.folio-wrapper {
  height: 50px;
}
.table {
  table-layout: fixed;
}
.tooltip-content {
  z-index: 9999;
}
</style>
